import dialogData from '@giro-app/modules/payment/store/dialogs/dialogDetran';

const subscribe = (store) => {
  dialogData.subscriber.subscribe(store);
};

export default {
  subscribe,
};
